module.exports = __webpack_public_path__ + "img/5.ee0ac71e.png";